'use strict';

import ModalUtil from 'standard-vote/app/scripts/util/modal.js';

module.exports = ModalUtil;



// WEBPACK FOOTER //
// ./app/scripts/util/modal.js